/* eslint-disable max-len */

import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

// Line icon via https://github.com/mapbox/mapbox-gl-draw/blob/master/dist/svg/point.svg
export default function DrawWaypointIcon(props: SvgIconProps) {
    return <SvgIcon {...props}>
        <g transform="translate(0,-1032.3622)">
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                }}
                d="m 36,1040.3622 c 6e-6,3.3093 -5.988612,10 -5.988612,10 0,0 -5.998776,-6.668 -6.011345,-9.9772 -0.01257,-3.3092 2.656576,-6.0039 5.965792,-6.0227 3.309189,-0.019 6.00884,2.6452 6.033992,5.9543"
                id="path12561" />
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    fill: '#ffffff',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                }}
                d="m 34.000115,1040.3622 c -5e-6,2.2062 -3.992523,7.0001 -3.992523,7.0001 0,0 -3.999291,-4.7787 -4.007679,-6.9849 -0.0084,-2.2062 1.771082,-4.0027 3.97731,-4.0153 2.20621,-0.013 4.006037,1.7635 4.022777,3.9697"
                id="path12563" />
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                }}
                d="M 9.9667969,1014.3622 C 6.6575809,1014.381 3.98743,1017.0764 4,1020.3856 c 0.012569,3.3092 6.011719,8.9766 6.011719,8.9766 0,0 5.988287,-5.6907 5.988281,-9 l 0,-0.045 c -0.02515,-3.3091 -2.724014,-5.9741 -6.0332031,-5.9551 z m 0.00977,2 c 2.2062061,-0.013 4.0066931,1.7626 4.0234331,3.9688 l 0,0.031 c -5e-6,2.2062 -3.992188,6 -3.992188,6 0,0 -3.999424,-3.7782 -4.007812,-5.9844 -0.0084,-2.2062 1.7703345,-4.003 3.9765625,-4.0156 z"
                id="path12568" />
            <path
                style={{
                    opacity: 1,
                    fill: 'currentColor',
                    fillOpacity: 1,
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'bevel',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                }}
                d="M 10 2 C 6.686292 2 4 4.6863 4 8 C 4 11.3137 10 17 10 17 C 10 17 16 11.3137 16 8 C 16 4.6863 13.313708 2 10 2 z M 10 4 C 12.071068 4 13.75 5.6789 13.75 7.75 C 13.75 9.2053278 11.93111 11.644393 10.830078 13 L 9.1699219 13 C 8.0688903 11.644393 6.25 9.2053278 6.25 7.75 C 6.25 5.6789 7.928932 4 10 4 z "
                transform="translate(0,1032.3622)"
                id="path17305" />
        </g>
    </SvgIcon>;
}
